module.exports = __webpack_public_path__ + "img/煤炭企业集团供应链管理的研究与实施—山东能源枣庄矿业（集团）有限责任公司—1-1.52b7ea6a.jpg";